import { MuiPickersUtilsProvider, KeyboardDatePicker } from "@material-ui/pickers";
import { makeStyles, createMuiTheme } from "@material-ui/core/styles";
import React, { useState, useEffect } from "react";
import { ThemeProvider } from "@material-ui/styles";
import { Calendar } from "react-feather";
import { Grid } from "@material-ui/core";
import PropTypes from "prop-types";
import DateFnsUtils from "@date-io/date-fns";
import ptLocale from "date-fns/locale/pt-BR";
import { withStyles } from "@material-ui/core/styles";

const tema = createMuiTheme({
  typography: {
    fontFamily: "CircularStd-Book"
  },
  palette: {
    primary: {
      main: "#20174A"
    }
  }
});

const styles = () => ({
  notchedOutline: {},
  focused: {
    "& $notchedOutline": {
      borderColor: "#e040fb !important"
    }
  },
  floatingLabelFocusStyle: {
    color: "#9b2caf !important"
  }
});

export const SelecaoData = props => {
  const {
    mensagemDataInvalida,
    mensagemDataMaxima,
    mensagemDataMinima,
    ocultarCalendario,
    campoRequerido,
    desativarCampo,
    cancelLabel,
    inputVariant,
    setInputFocus,
    inputFocus,
    dataMinima,
    dataMaxima,
    etiqueta,
    onChange,
    onBlur,
    variant,
    estilos,
    formato,
    autoOk,
    valor,
    erro,
    id
  } = props;

  const classes = useStyles();
  const [focusOut, setStateFocusOut] = useState(false);
  const [erroCamportamento, setErroCamportamento] = useState(false);

  const dataMaximaTratada = dataMaxima;
  if (dataMaximaTratada) dataMaximaTratada.setSeconds(59);

  let valorTratado = valor;
  if (valorTratado) {
    const dataSelecionada = new Date(valorTratado);
    valorTratado = new Date(
      dataSelecionada.getFullYear(),
      dataSelecionada.getMonth(),
      dataSelecionada.getDate()
    );
  }
  useEffect(() => {
    const erroPorCampoObrigatorio = campoRequerido && focusOut && !valorTratado;
    const erroPorDataInvalida = isNaN(valorTratado);
    const erroPorDataForaDosLimites = valorTratado < dataMinima || valorTratado > dataMaximaTratada;

    setErroCamportamento(
      erroPorCampoObrigatorio ||
        (valorTratado && (erroPorDataInvalida || erroPorDataForaDosLimites))
    );
  }, [campoRequerido, valorTratado, focusOut, dataMinima, dataMaximaTratada]);

  const focus = input => {
    if (input) {
      input.focus();
    }
  };

  const propriedadesEntrada = inputFocus
    ? {
        variant: "outlined",
        inputRef: focus,
        classes: { notchedOutline: classes.notchedOutline, focused: classes.focused }
      }
    : {
        variant: "outlined",
        classes: { notchedOutline: classes.notchedOutline, focused: classes.focused }
      };

  const propriedadesLabelProps = {
    classes: { focused: classes.floatingLabelFocusStyle }
  };

  const inputAdornmentProps = ocultarCalendario
    ? { classes: { root: classes.esconderIconeDatePicker } }
    : { onBlur: () => setStateFocusOut(true) };

  const handleOnBlur = event => {
    setStateFocusOut(true);
    setInputFocus && setInputFocus(false);
    if (onBlur) onBlur(event);
  };

  return (
    <Grid container>
      <Grid item xs={12} onFocus={() => setStateFocusOut(false)}>
        <ThemeProvider theme={tema}>
          <MuiPickersUtilsProvider utils={DateFnsUtils} locale={ptLocale}>
            <KeyboardDatePicker
              keyboardIcon={<Calendar color="#61688B" size={24} />}
              InputAdornmentProps={inputAdornmentProps}
              invalidDateMessage={mensagemDataInvalida}
              InputLabelProps={propriedadesLabelProps}
              onBlur={handleOnBlur}
              maxDateMessage={mensagemDataMaxima}
              minDateMessage={mensagemDataMinima}
              InputProps={propriedadesEntrada}
              inputVariant={inputVariant}
              className={classes.entrada}
              error={erroCamportamento || (!valor && erro)}
              required={campoRequerido}
              disabled={desativarCampo}
              cancellabel={cancelLabel}
              maxDate={dataMaxima}
              minDate={dataMinima}
              value={valorTratado}
              onChange={onChange}
              variant={variant}
              label={etiqueta}
              format={formato}
              style={estilos}
              autoOk={autoOk}
              id={id}
            />
          </MuiPickersUtilsProvider>
        </ThemeProvider>
      </Grid>
    </Grid>
  );
};

const useStyles = makeStyles({
  esconderIconeDatePicker: {
    display: "none"
  },
  entrada: {
    display: "flex",
    width: "100%"
  },
  notchedOutline: {},
  focused: {
    "& $notchedOutline": {
      borderColor: "#e040fb !important"
    }
  },
  floatingLabelFocusStyle: {
    color: "#9b2caf !important"
  }
});

SelecaoData.propTypes = {
  mensagemDataInvalida: PropTypes.string,
  mensagemDataMaxima: PropTypes.string,
  mensagemDataMinima: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  onBlur: PropTypes.func,
  ocultarCalendario: PropTypes.bool,
  campoRequerido: PropTypes.bool,
  desativarCampo: PropTypes.bool,
  cancelLabel: PropTypes.string,
  inputVariant: PropTypes.string,
  etiqueta: PropTypes.string,
  inputFocus: PropTypes.bool,
  setInputFocus: PropTypes.func,
  variant: PropTypes.string,
  dataMinima: PropTypes.any,
  dataMaxima: PropTypes.any,
  estilos: PropTypes.object,
  formato: PropTypes.string,
  autoOk: PropTypes.bool,
  valor: PropTypes.any,
  erro: PropTypes.bool
};

SelecaoData.defaultProps = {
  mensagemDataMaxima: "A data inserida não pode estar no futuro",
  dataMinima: new Date(new Date().getFullYear() - 130, 0, 1),
  mensagemDataMinima: "A data inserida é muito antiga",
  mensagemDataInvalida: "Data inválida",
  proriedadesPersonalizadas: {},
  inputVariant: "outlined",
  ocultarCalendario: false,
  dataMaxima: new Date(),
  campoRequerido: false,
  desativarCampo: false,
  cancelLabel: "Cancelar",
  formato: "dd/MM/yyyy",
  variant: "inline",
  inputFocus: false,
  etiqueta: "",
  autoOk: true,
  estilos: {},
  valor: null,
  erro: false
};

export default withStyles(styles)(SelecaoData);
